import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import { compose } from 'redux';
import classNames from 'classnames'

import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Dropdown } from 'primereact/dropdown';
import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import { InputText } from 'primereact/inputtext';
import { Toast } from 'primereact/toast';

import Header from '@components/Header';
import { getAllowedCountries } from '@utils/countryPermissions';
import DetailUserModal from '@components/Users/DetailUserModal';

import { getUsersInternals, getTotalUsers, changeStatusUser } from '@actions/users';
import { getBusiness } from '@actions/business';
import { validatePermissionAction } from '@actions/sessionPermission';

import { StatusString } from '@constants/general'
import catalogPermissionsId from '@constants/catalogPermissionsId';

import './style.scss'

class Internals extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showModal: {
        isVisible: false,
        title: '',
        children: null,
        textOk: '',
        textHide: '',
        actionOk: null,
        actionHide: () => {},
      },
      users: [],
      loading: false,
      totalRecords: 0,
      lazyParams: {
        first: 0,
        rows: 6,
        page: 0,
      },
      type: 'internal',
      findText: '',
      typeCountry: null,
      typeStatus: null,
      searchValues: {
        country: null,
        company: null,
        status: null,
        find: '',
      },
      showModalDetail: {
        isVisible: false,
        data: {},
      },
      countryRequired: false,
      catalogCompanies: []
    };
    this.catalogStatus = [
      {label: this.props.t('Activos/Suspendidos') , id: StatusString.STATUS_SHOWABLE },
      {label: this.props.t('Activo') , id: StatusString.STATUS_ACTIVE },
      {label: this.props.t('Suspendido') , id: StatusString.STATUS_SUSPENDED }
    ]
  }

  componentDidMount() {
    // this.onChange({target: { name: 'typeStatus', value: this.catalogStatus[0] }})
    // this.loadTotal();
  }

  searchData = () => {
    const { findText, typeCountry, typeStatus, typeCompany } = this.state
    this.setState({
      searchValues: {
        country: typeCountry?.id || '',
        company: typeCompany?.id || '',
        status: typeStatus?.id || StatusString.STATUS_SHOWABLE,
        find: findText || '',
      },
    }, () => this.loadTotal())
  }

  loadTotal = async () => {
    const { getTotalUsers } = this.props
    const { type, searchValues } = this.state
    if (!searchValues.country) return this.setState({countryRequired: true})
    this.setState({ loading: true });

    const querys = {
      status: searchValues.status || StatusString.STATUS_SHOWABLE
    }
    if (searchValues.country) querys.country = searchValues.country
    if (searchValues.company) querys.company = searchValues.company
    if (searchValues.find) querys.find = searchValues.find

    const response = await getTotalUsers(querys);
    if (!response?.status) {
      this.setState({
        totalRecords: response.data.total
      });
      this.loadData()
    } else {
      this.setState({ loading: false});
    }
  }

  loadData = async () => {
    const { getUsersInternals } = this.props;
    const { lazyParams, searchValues } = this.state;
    this.setState({ loading: true });
    const querys = {
      page: lazyParams.page + 1,
      rows: lazyParams.rows,
      status: searchValues.status || StatusString.STATUS_SHOWABLE

    };
    if (lazyParams.sortField) {
      let validate = ''
      if (lazyParams.sortField === 'nombre') validate = 'name'
      if (lazyParams.sortField === 'empresa') validate = 'company'
      if (lazyParams.sortField === 'correo') validate = 'email'
      if (lazyParams.sortField === 'puesto') validate = 'position'
      if (lazyParams.sortField === 'estatus') validate = 'status'
      querys.sortField = validate
    }
    if (lazyParams.sortOrder) querys.sortOrder = lazyParams.sortOrder ? 'asc' : 'desc';
    if (searchValues.country) querys.country = searchValues.country
    if (searchValues.company) querys.company = searchValues.company
    if (searchValues.find) querys.find = searchValues.find
    const response = await getUsersInternals(querys);
    if (!response?.status) {
      return this.setState({
        users: response.data,
        loading: false,
      });
    } 
    return this.setState({
      users: [],
      loading: false,
    });
    
  };

  seCompaniesByCountry = async () => {
    const { getBusiness } = this.props
    const { typeCountry } = this.state
    this.setState({catalogCompanies: []})
    const params = {
      type: 'visible',
      country: typeCountry?.id || ''
    };
    const response = await getBusiness(params);
    if (!response?.status) {
      const catalogCompanies = response.data.map(item => ({ label: item.nombre, id: item.id }))
      return this.setState({catalogCompanies})
    }

  }

  onPage = (event) => {
    const { lazyParams } = this.state;
    const _lazyParams = { ...lazyParams, ...event };
    console.log('event onPage', event);
    this.setState({ lazyParams: _lazyParams }, this.loadData);
  };

  onSort = (event) => {
    const { lazyParams } = this.state;
    const _lazyParams = { ...lazyParams, ...event };
    console.log('event onSort', event);
    this.setState({ lazyParams: _lazyParams }, () => this.loadData());
  };

  onChangeSearch = (e) => {
    console.log(e);
    const { searchValues } = this.state;
    this.setState({
      searchValues: { ...searchValues, [e.target.name]: e.value },
    });
  };
  
  columnResponsive = (rowData, detail) => (
    <>
        <span className="p-column-title">{detail.header}</span>
        {rowData[detail.field]}
    </>
  )

  statusTemplate = (node, detail) => {
    const { t } = this.props
    if (node.estatus === StatusString.STATUS_SUSPENDED) {
      return (
        <>
          <span className="p-column-title">{detail.header}</span>
          <span className="badge-red" aria-hidden="true"> {t('Suspendido').toUpperCase()} </span>
        </>
      );
    }
    if (node.estatus === StatusString.STATUS_ACTIVE) {
      return (
        <>
          <span className="p-column-title">{detail.header}</span>
          <span  aria-hidden="true"> {t('Activo')} </span>
        </>
      );
    }
  }

  detailTemplate = (rowData, detail) => (
    <>
      <span className="p-column-title">{detail.header}</span>
      <Button
        icon="pi pi-id-card"
        className=" p-button-text p-button-primary p-mr-2"
        onClick={() => this.showDetailUser(rowData)}
      />
    </>
  );

   
  onChange = ({target}) => {

    this.setState({[target.name]: target.value}, () => {
      if (target.name === "typeCountry") {
        this.setState({countryRequired: false})
        this.seCompaniesByCountry()
      }
    });
  };

  showDetailUser = (detail) => {
    this.setState({
      showModalDetail: {
        isVisible: true,
        data: detail
      },
    });
  };

  onHideModal = () => {
    this.setState({
      showModal: {
        isVisible: false,
        actionHide: () => {},
      },
    });
  };

  changeStatusUserAction = async ({justification, ...data}) => {
    const { changeStatusUser, t } = this.props
    this.setState({loading: true})
    const response = await changeStatusUser({...data, justification})
    if (!response?.status) {
      this.toast.show({
        severity: 'success',
        summary: t('Confirmación'),
        detail: t('La operación se ha realizado de manera éxitosa'),
        life: 3000,
      });
      this.setState({showModalDetail: {isVisible: false}})
      this.loadData()
    }
    this.setState({loading: false})
  }

  render() {
    const { t, history, countriesCurrentCatalog, validatePermissionAction } = this.props
    const {
      showModal,
      users,
      lazyParams,
      totalRecords,
      loading,
      typeCountry,
      typeStatus,
      findText,
      showModalDetail,
      typeCompany,
      catalogCompanies,
      countryRequired
    } = this.state;

    const footerModal = (
      <div>
        {showModal.actionOk && (
          <Button label={showModal.textOk} onClick={showModal.actionOk} />
        )}
        {showModal.actionHide && (
          <Button label={showModal.textHide} onClick={showModal.actionHide} />
        )}
      </div>
    );

    const rightHeader = (
      <>
        <Button
          icon="pi pi-th-large"
          className="p-button-raised p-button-text p-button-plain"
          onClick={() => history.push('/dashboard')}
        />
        { validatePermissionAction(catalogPermissionsId.CARGA_MASIVA_DE_USUARIOS_INTERNOS) && (
          <Button
            label={t('Carga masiva')}
            className="p-button-primary"
            onClick={() => history.push({pathname: '/users/internal/bulk-load',state: {typeCompany,catalogCompanies,typeCountry}})}
          />
        )}
      </>
    );

    const headerTable = (
      <div className="p-grid">
        <div className="p-col-12 p-md-4 p-lg-4 p-d-flex p-ai-center">
          <label className="p-mr-2 p-text-bold">{t('País')}:</label>
          <Dropdown
            name="typeCountry"
            value={typeCountry}
            options={countriesCurrentCatalog}
            onChange={this.onChange}
            optionLabel="label"
            filter
            // showClear
            filterBy="label"
            placeholder=""
            style={{ width: '100%' }}
            className={classNames({
              'p-invalid': countryRequired,
            })}
          />
        </div>
        <div className="p-col-12 p-md-4 p-lg-4 p-d-flex p-ai-center">
          <label className="p-mr-2 p-text-bold">{t('Empresa')}:</label>
          <Dropdown
              name="typeCompany"
              value={typeCompany}
              options={catalogCompanies}
              onChange={this.onChange}
              optionLabel="label"
              filter
              // showClear
              filterBy="label"
              placeholder=""
              style={{ width: '100%' }}
              disabled={!typeCountry}
            />
        </div>
        <div className="p-col-12 p-md-4 p-lg-4 p-d-flex p-ai-center">
          <label className="p-mr-2 p-text-bold">{t('Estatus')}:</label>
          <Dropdown
              name="typeStatus"
              value={typeStatus}
              options={this.catalogStatus}
              onChange={this.onChange}
              optionLabel="label"
              filter
              // showClear
              filterBy="label"
              placeholder=""
              style={{ width: '100%' }}
            />
        </div>
        <div className="p-col-12 p-md-8 p-lg-8" />
        <div className="p-col-12 p-md-4 p-lg-4 p-d-flex p-ai-center p-flex-column p-flex-sm-row p-jc-sm-end">
          <label className="p-mr-2 p-text-bold">{t('Texto')}:</label>
            <InputText
              name="findText"
              value={findText}
              onChange={this.onChange}
              className="p-mr-2 input-search-list"
              style={{'width': '58%'}}
              // style={{ width: '100%' }}
            />
          <Button
            icon="pi pi-search"
            label={t('Buscar')}
            className="p-button-raised p-button-text p-button-plain btn-search-list"
            onClick={() => this.searchData()}
          />
        </div>
      </div>
    );

    return (
      <div className="p-grid">
        <div className="p-col-12">
          <Header title={t('Usuarios internos')} rightComponent={rightHeader} />
          <div className="card">
            <div className="p-grid">
              <div className="p-col-12">
                <DataTable
                  value={users}
                  lazy
                  paginator={users.length ? true : false}
                  first={lazyParams.first}
                  rows={lazyParams.rows}
                  totalRecords={totalRecords}
                  onPage={this.onPage}
                  onSort={this.onSort}
                  loading={loading}
                  header={headerTable}
                  className="table-internals"
                >
                  <Column field="empresa" header={t("Empresa")} body={this.columnResponsive} sortable />
                  <Column field="nombre" header={t("Nombre")} body={this.columnResponsive} sortable />
                  <Column
                    field="correo"
                    header={t("Correo electrónico")}
                    body={this.columnResponsive}
                    className=""
                    sortable
                  />
                  <Column field="puesto" header={t("Puesto")} body={this.columnResponsive} className="column-medium" sortable />
                  <Column field="estatus" header={t("Estatus")} body={this.statusTemplate} className="column-medium" sortable />
                  <Column header={t("Ver ficha")} body={this.detailTemplate} className="column-action p-text-center-lg"/>
                </DataTable>
              </div>
              { !users.length && (
                <div className="p-col-12 not-information">
                  {t('No se encontraron resultados')}
                </div>
              )
              }
            </div>
          </div>
        </div>
        { showModalDetail.isVisible && (
          <DetailUserModal
            onHidden={() => this.setState({showModalDetail: {isVisible: false}})}
            data={showModalDetail.data}
            continueAction={this.changeStatusUserAction}
          />
        )}
        <Dialog
          header={showModal.title}
          visible={showModal.isVisible}
          breakpoints={{'960px': '90vw'}}
          style={{ width: '35vw' }}
          footer={footerModal}
          onHide={showModal.actionHide}
        >
          {showModal.children}
        </Dialog>
        <Toast ref={(el) => (this.toast = el)} />
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  countriesCurrentCatalog: getAllowedCountries(state.catalogs.countriesCurrentCatalog, state.sessionPermission),
});

const mapDispatchToProps = {
  getUsersInternals,
  getTotalUsers,
  changeStatusUser,
  getBusiness,
  validatePermissionAction
};

export default compose(
  withTranslation(),
  connect(mapStateToProps, mapDispatchToProps)
  )(Internals);
